import { SerializedData, Store } from "bernie-core";
import { action, observable } from "mobx";
import { Logger } from "bernie-logger";

export interface FlexModuleModel {
  responsePending: boolean;
  empty: boolean;
  error: boolean;
  model: object;
}

/**
 * Store that contains Flex Microservice model responses
 * returned by compositor in Map, addressible by module id
 */
export class FlexModuleModelStore extends Store {
  @observable
  public modelMap: Map<string, FlexModuleModel>; // this is a Map because a plain object is not as observable

  private modelMapAsObject: object;

  public constructor(state: SerializedData, logger: Logger) {
    super(state, logger);
    this.modelMap = new Map();
  }

  public hydrate(data: SerializedData): void {
    // Map isn't serializable: convert modelMapAsObject back to Map
    /* istanbul ignore else */
    if (data.modelMapAsObject) {
      Object.getOwnPropertyNames(data.modelMapAsObject).forEach((key) => {
        this.modelMap.set(key, data.modelMapAsObject[key]);
      });
    }
  }

  @action
  public updateModelMap(id: string, flexModuleModel: FlexModuleModel) {
    this.modelMap.set(id, flexModuleModel);
  }

  public toJSON(): SerializedData {
    // Map isn't serializable: convert modelMap to modelMapAsObject
    this.modelMapAsObject = {};
    this.modelMap.forEach((value, key) => (this.modelMapAsObject[key] = value));

    // TODO: remove "modelMapAsObject" from list when composition can be removed from CompositionStore serialized state
    // having both composition and modelMapAsObject duplicates data, inflating the size of the HTML response
    return super.toJSON(["modelMap", "modelMapAsObject"]);
  }
}
